import { Button } from '@creanizer/ui'
import { Save } from 'lucide-react'
import type { SunoPromptResult } from '@creanizer/types'
import { SunoPromptResult as SunoPromptResultDisplay } from './SunoPromptResult'

interface SunoPromptBatchResultsProps {
  results: SunoPromptResult[]
  onSave: (result: SunoPromptResult, index: number) => void
  onSaveAll: () => void
  isSaved?: (result: SunoPromptResult) => boolean
}

export function SunoPromptBatchResults({
  results,
  onSave,
  onSaveAll,
  isSaved = () => false
}: SunoPromptBatchResultsProps) {
  // 防御的チェック - 無効なデータをフィルタリング
  const validResults = results?.filter(r => r && r.promptInfo) || []

  if (validResults.length === 0) {
    return (
      <div className="text-center text-muted-foreground p-4">
        有効なプロンプトデータがありません
      </div>
    )
  }

  const allSaved = validResults.every(r => isSaved(r))

  return (
    <div className="space-y-4">
      {validResults.length > 1 && (
        <div className="flex justify-end">
          <Button
            onClick={onSaveAll}
            disabled={allSaved}
          >
            <Save className="h-4 w-4 mr-2" />
            すべて保存 ({validResults.length}個)
          </Button>
        </div>
      )}

      {validResults.map((result, index) => (
        <div key={index} className="card p-6">
          <SunoPromptResultDisplay
            result={result}
            onSave={() => onSave(result, index)}
            batchResults={validResults.length > 1 ? validResults : []}
            onSelectBatchResult={() => {}}
          />
        </div>
      ))}
    </div>
  )
}